import UserAvatar from './UserAvatar.js';

export default UserAvatar;
